<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-sm" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 class="modal-title">Pedido {{ $platform.setting.number_symbol }}{{ data.id }}
					</h4>
				</div>
				<div class="list-group m-b-0">
					<router-link
						@click.native="close"
						class="list-group-item"
						:to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.id">
						<i class="fa fa-eye fa-fw" aria-hidden="true"></i>
						Ver 
					</router-link>

					<a
						@click="close"
						target='_blank'
						class="list-group-item"
						:href="data.link">
						<i class="fa fa-file-pdf-o fa-fw" aria-hidden="true"></i>
						Ver PDF
					</a>

					<template v-if="!data.budget">
						<template v-if="!data.parent">
							<router-link @click.native="close" :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/management/orders/' + data.id + '/edit'" class="list-group-item">
								<i class="ti-pencil-alt fa-fw"></i>
								Editar
							</router-link>
						</template>
					</template>

					<button @click="destroy(data)" type="button" class="list-group-item">
						<i class="icon-trash fa-fw"></i>
						Eliminar
					</button>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'orders-actions-' + new Date().getTime(),
				},

				data: null
			}
		},
		methods: {
			open(data) {
				if(data) {
					this.data = data
				} else {
					this.data = null
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			destroy(data) {
				this.close()
				this.$emit('destroy', data)
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Actions.vue